<template>
  <div class="empty-table-wrapper">
    <div class="empty-table-container">
      <div class="empty-icon" :class="`${icon}${dark ? '-black' : ''}`" />
      <p v-safe-html="message" />
      <router-link
        v-if="action && action.routeParams && !action.disabled"
        class="btn primary"
        :class="{ icon: action.icon }"
        :to="action.routeParams"
      >
        {{ action.label }}
        <i v-if="icon" :class="icon" />
      </router-link>
      <Button
        v-else-if="action && action.click"
        class="primary"
        :label="action.label"
        :icon="icon"
        :class="{ icon: action.icon }"
        :disabled="action.disabled"
        @click="action.click()"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    required: true,
  },
  action: {
    type: Object,
  },
  icon: {
    type: String,
    required: true,
  },
  dark: {
    type: Boolean,
    required: true,
  },
});
</script>
